import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink } from "react-router-dom";
import config from "../../config";
import { getLogout, role, email, lmspwd } from "../Actions/AuthAction";

const LeftSidebar = (props) => {
  const logout = (e) => {
    //alert("fsdf");
    getLogout(props);
  };

  return (
    <>
      <div id="layoutSidenav_nav">
        <nav
          className="sb-sidenav accordion sb-sidenav-light"
          id="sidenavAccordion"
        >
          <div className="sb-sidenav-menu">
            <Link class="navbar-brand" to="/dashboard">
              <img
                src={`${config.DOMAIN_URL}/assets/img/logo.png`}
                className="logo"
              />
            </Link>
            <div className="nav mt-5">
              <Link className="nav-link" activeClassName="active" to="/">
                <div className="sb-nav-link-icon">
                  <i className="fas fa-tachometer-alt"></i>
                </div>
                Dashboard
              </Link>

              <Link className="nav-link" activeClassName="active" to="/profile">
                <div className="sb-nav-link-icon">
                  <i className="fas fa-user"></i>
                </div>
                Profile
              </Link>
              <a
                className="nav-link collapsed"
                data-toggle="collapse"
                data-target="#collapseLayouts"
                aria-expanded="false"
                aria-controls="collapseLayouts"
              >
                <div className="sb-nav-link-icon">
                  <i className="fa fa-address-card"></i>
                </div>
                Drives
                <div className="sb-sidenav-collapse-arrow">
                  <i className="fas fa-angle-down"></i>
                </div>
              </a>
              <div
                className="collapse"
                id="collapseLayouts"
                aria-labelledby="headingOne"
                data-parent="#sidenavAccordion"
              >
                <nav className="sb-sidenav-menu-nested nav">
                  <Link to="/drivelist" className="nav-link">
                    List
                  </Link>
                  <Link to="/applieddrivelist" className="nav-link">
                    Applied List
                  </Link>
                  <Link to="/selecteddrivelist" className="nav-link">
                    Selected List
                  </Link>
                </nav>
              </div>
              {/* <form
                action="https://course.rozgar.com/login/index.php"
                name="loginform"
                id="loginform"
                method="POST"
              >
                <input type="text" value={email()} name="username" hidden />

                <input
                  type="password"
                  value={lmspwd()}
                  name="password"
                  hidden
                />

                <button
                  type="submit"
                  className="nav-link bg-transparent border-0"
                >
                  <div className="sb-nav-link-icon">
                    <i className="fas fa-book"></i>
                  </div>
                  Courses
                </button>
              </form> */}

              <a
                className="nav-link"
                href={`https://store.rozgar.com/shop/?e=${btoa(
                  email()
                )}&p=${btoa(lmspwd())}&via=campus`}
                target="_blank"
              >
                <div className="sb-nav-link-icon">
                  <i className="fas fa-shopping-cart"></i>
                </div>
                Store
              </a>
              <Link to="/support" class="nav-link">
                <div class="sb-nav-link-icon">
                  <i class="fas fa-life-ring"></i>
                </div>
                Support
              </Link>
            </div>
          </div>
          <div className="sb-sidenav-footer">
            <div className="small">Logged in as:</div>
            <span className="text-danger font-weight-bold">{role()}</span>
          </div>
        </nav>
      </div>
    </>
  );
};
export default LeftSidebar;
